import { gql } from '@apollo/client';
import { StoreInfo } from '../fragments';

export default gql`
  query store($id: ID) {
    store(id: $id) {
      ...StoreInfo
    }
  }
  ${StoreInfo}
`;
